import { formatPrices } from './format_prices.js'
import { printProduct, q } from './print_products.js'
import { handleEvent } from '../utils/events.js'
import { setupHidePrices, priceStatus } from './hide_prices.js'

function cart_events() {
    const forms = document.querySelectorAll(`[data-name="product-form"]`)
    forms.forEach((form) => {
        const sizes = form.querySelectorAll('.size-container')

        sizes.forEach((size) => {
            const input = size.querySelector('input')
            const minus = size.querySelector('button.minus')
            const plus = size.querySelector('button.plus')

            minus?.addEventListener('click', (e) => {
                input.value = Number(input.value) - 1 >= 0 ? Number(input.value) - 1 : 0
            })
            plus?.addEventListener('click', (e) => {
                input.value = Number(input.value) + 1 <= Number(size.dataset.stock) ? Number(input.value) + 1 : Number(size.dataset.stock)
            })
            input?.addEventListener('keyup', ({ target }) => {
                if (target.value === '') return null;
                let value = parseInt(target.value, 10)

                if (isNaN(value) || value < 0) {
                    value = 0
                }
                if (value > Number(size.dataset.stock)) {
                    value = Number(size.dataset.stock)
                }

                target.value = value;
            })
        })

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const sizes = form.querySelectorAll('.size-container')

            const items = []
            sizes.forEach((size) => {
                const input = size.querySelector('input')
                if (!input) return;
                if (Number(input.value) > 0) {
                    items.push({
                        stock: Number(size.dataset.stock),
                        id: Number(size.dataset.priceId),
                        code: size.dataset.sku,
                        cantidad: Number(input.value)
                    })
                }
            })


            const _e = {
                name: 'addedToCartObjectIDs',
                algolia_event: 'addedToCartObjectIDs',
                url: '/products',
                payload: {
                    product_id: form.dataset.id,
                    code: form.dataset.code,
                    items
                },
            }
            handleEvent(_e, undefined, { require_location: true })

            window.cart = items
            if (window.addItemToCart) {
                window.addItemToCart();
                sizes.forEach((size) => {
                    const input = size.querySelector('input')
                    if (!input) return;
                    input.value = 0
                })
            }
        })
    })
}

function product_redirect() {
    const products = document.querySelectorAll(`.product`)
    products.forEach((product) => {
        const link = product.querySelector('.product__data')
        const link2 = product.querySelector('.product__details')
        async function fn(e) {
            e.stopPropagation();
            e.preventDefault()
            const { id } = product.dataset
            if (id) {
                const e = {
                    name: 'clickedObjectIDs',
                    algolia_event: 'clickedObjectIDs',
                    url: '/products',

                    payload: {
                        product_id: id,
                        ...q,
                    },
                }
                handleEvent(e, undefined, { require_location: true })
                formatPrices()
            }
            const url = link?.href || link2?.href
            window.location.href = url // 🔗 Abre en nueva pestaña
        }
        link?.addEventListener('click', fn)
        link2?.addEventListener('click', fn)
    })
    formatPrices()
    priceStatus()
}

function print(data, isNext) {
    const products_list = document.querySelector('#products-list')

    if (isNext) {
        const prods = document.querySelector('#products')
        prods.innerHTML = prods.innerHTML + data.products.map((p) => printProduct(p, true)).join('')
    } else {
        // Mostrar producto
        products_list.innerHTML = `
         <div class="products" id="products">
            ${data.products.map((p) => printProduct(p)).join('')}
         </div>
      `
    }
}

async function handleQuery(isNext) {
    const params = []
    const param = (prefix, str) => `${prefix}=` + encodeURIComponent(str)

    if (q.query) params.push(param('query', q.query))
    if (q.brands.length) params.push(param('brands', q.brands.join(',')))
    if (q.categories.length) params.push(param('categories', q.categories.join(',')))
    if (q.subcategories.length) params.push(param('subcategories', q.subcategories.join(',')))
    if (q.models.length) params.push(param('models', q.models.join(',')))
    if (q.page > 0) params.push(param('page', q.page))
    if (q.order) params.push(param('order', q.order))

    history.replaceState(null, '', params.length ? '?' + params.join('&') : '?')
    const response = await fetch(`/api/test${params.length ? '?' + params.join('&') : ''}`)

    const curr_page = document.querySelector('#curr-page')

    const brands_a = []
    const cat_a = []
    const subcat_a = []
    const model_a = []

    if (q.brands.length !== 0) {
        q.brands.forEach(function (brand) {
            brands_a.push(`<a href="/products?brands=${brand.toUpperCase()}">${brand.toUpperCase()}</a>`)
        })
    }

    if (q.categories.length !== 0) {
        q.categories.forEach(function (cat) {
            let aux = cat.split('').map((l, i) => i === 0 ? l.toUpperCase() : l).join('')
            cat_a.push(`<a href="/products?categories=${cat.toUpperCase()}">${aux}</a>`)
        })
    }

    if (q.subcategories.length !== 0) {
        q.subcategories.forEach(function (subcat) {
            let aux = subcat.split('').map((l, i) => i === 0 ? l.toUpperCase() : l).join('')
            subcat_a.push(`<a href="/products?subcategories=${subcat.toUpperCase()}">${aux}</a>`)
        })
    }

    if (q.models.length !== 0) {
        q.models.forEach(function (model) {
            let aux = model.split('').map((l, i) => i === 0 ? l.toUpperCase() : l).join('')
            model_a.push(`<a href="/products?models=${model.toUpperCase()}">${aux}</a>`)
        })
    }

    curr_page.innerHTML = `
   <div class="link">
         <span>Inicio</span>
   </div>
   ${brands_a.length > 0
            ? `
     <div class="link">
         <span>&#47;</span>
         ${brands_a.join('<span>&sol;</span>')}
   </div> `
            : ''
        }
   ${cat_a.length > 0
            ? `
      <div class="link">
          <span>&#47;</span>
          ${cat_a.join('<span>&sol;</span>')}
    </div> `
            : ''
        }
    ${subcat_a.length > 0
            ? `
      <div class="link">
          <span>&#47;</span>
          ${subcat_a.join('<span>&sol;</span>')}
    </div> `
            : ''
        }
    ${model_a.length > 0
            ? `
      <div class="link">
          <span>&#47;</span>
          ${model_a.join('<span>&sol;</span>')}
    </div> `
            : ''
        }
    ${q.query
            ? `
      <div class="link query">
         <i>&sol;</i>
         <span>resultado de búsqueda</span>
         <span>"${q.query}"</span>
      </div> `
            : ''
        }
   `

    const data = await response.json()

    const c_brands = document.querySelector('#brands-filters')
    const c_categories = document.querySelector('#categories-filters')
    const c_subcategories = document.querySelector('#subcategories-filters')
    const c_models = document.querySelector('#models-filters')

    function handle(container, items, selected, type) {
        container.innerHTML = ``
        for (const item of items) {
            if (!item) continue

            const input = document.createElement('input')
            const _check = document.createElement('div')

            _check.classList.add('checkbox')
            const label = document.createElement('label')

            input.name = item
            input.id = item
            input.dataset['name'] = `${type}-check`
            input.dataset['value'] = item
            input.type = 'checkbox'

            label.htmlFor = item
            const aux = type === 'brand' ? item.toUpperCase('') : item.toLowerCase().split('').map((l, i) => (i === 0 ? l.toUpperCase() : l)).join('')
            const textNode = document.createTextNode(aux)

            label.appendChild(_check)
            label.appendChild(textNode)

            const cont = document.createElement('div')

            cont.appendChild(input)
            cont.appendChild(label)

            if (selected.map((s) => s.toLowerCase()).includes(item.toLowerCase())) {
                input.checked = true
                label.classList.add('active')
                label.classList.add('active')
            }

            // Si está seleccionado inicialmente

            // actualizar _check al cambiar
            input.addEventListener('change', () => {
                if (input.checked) {
                    label.classList.add('active')
                } else {
                    label.classList.remove('active')
                }
            })

            container.appendChild(cont)
        }
    }

    handle(c_brands, data.filters.brands, q.brands, 'brand')
    handle(c_categories, data.filters.categories, q.categories, 'category')
    handle(c_subcategories, data.filters.subcategories, q.subcategories, 'subcategory')
    handle(c_models, data.filters.models, q.models, 'model')

    print(data, isNext)
    filterEvents()

    formatPrices(q.page)
    product_redirect()
    cart_events()
    priceStatus()
}

function filterEvents() {
    const brand_inputs = document.querySelectorAll(`[data-name="brand-check"]`)
    const category_inputs = document.querySelectorAll(`[data-name="category-check"]`)
    const subcategory_inputs = document.querySelectorAll(`[data-name="subcategory-check"]`)
    const model_inputs = document.querySelectorAll(`[data-name="model-check"]`)

    function changeLabel(element, status) {
        const el = element.parentNode.querySelector('label')
        if (status) el.classList.add('active')
        else el.classList.remove('active')
    }

    brand_inputs.forEach((brand) => {
        changeLabel(brand, brand.checked)
        brand.addEventListener('change', (e) => {
            const isChecked = e.target.checked
            if (isChecked) q.brands.push(e.target.name)
            else q.brands = q.brands.filter((b) => b !== e.target.name)
            brand.checked = isChecked
            changeLabel(brand, isChecked)
            handleQuery()
        })
    })

    category_inputs.forEach((category) => {
        changeLabel(category, category.checked)
        category.addEventListener('change', (e) => {
            const isChecked = e.target.checked
            if (isChecked) q.categories.push(e.target.name)
            else q.categories = q.categories.filter((b) => b !== e.target.name)
            changeLabel(category, isChecked)
            handleQuery()
        })
    })

    subcategory_inputs.forEach((subcategory) => {
        changeLabel(subcategory, subcategory.checked)
        subcategory.addEventListener('change', (e) => {
            const isChecked = e.target.checked
            if (isChecked) q.subcategories.push(e.target.name)
            else q.subcategories = q.subcategories.filter((b) => b !== e.target.name)
            changeLabel(subcategory, isChecked)
            handleQuery()
        })
    })

    model_inputs.forEach((model) => {
        changeLabel(model, model.checked)
        model.addEventListener('change', (e) => {
            const isChecked = e.target.checked
            if (isChecked) q.models.push(e.target.name)
            else q.models = q.models.filter((b) => b !== e.target.name)
            changeLabel(model, isChecked)
            handleQuery()
        })
    })
}

function handle_page() {
    const btn = document.querySelector('#next-page')

    const search_params = new URLSearchParams(window.location.search)
    const search_obj = Object.fromEntries(search_params.entries())

    q.query = search_obj.query || ''
    q.brands = search_obj.brands?.split(',') || []
    q.categories = search_obj.categories?.split(',') || []
    q.subcategories = search_obj.subcategories?.split(',') || []
    q.models = search_obj.models?.split(',') || []
    q.page = Number(search_obj.page) || 0
    q.page = Number(search_obj.page) || 0

    filterEvents()

    btn.addEventListener('click', async (e) => {
        q.page += 1
        await handleQuery(true)
        priceStatus()
    })
}

function expandFilters() {
    const handlers = document.querySelector('#filter-handler')
    const buttons = handlers.querySelectorAll('button')

    buttons.forEach((btn) => {
        const expand = btn.parentNode.querySelector(`#${btn.id}-filters`)
        if (expand) expand.style.display = 'none'

        btn.addEventListener('click', (e) => {
            const omit = ['clear-filters']
            if (btn.id === 'clear-filters') {
            }
            if (!expand || omit.includes(btn.id)) return null
            if (expand.style.display === 'none') {
                expand.style.display = 'block'
                const i = btn.querySelector('i')
                i.style.transform = 'rotate(180deg)'
            } else {
                expand.style.display = 'none'
                const i = btn.querySelector('i')
                i.style.transform = 'rotate(0deg)'
            }
        })
    })
}

window.addEventListener('DOMContentLoaded', () => {
    handle_page()
    formatPrices()
    product_redirect()
    cart_events()

    expandFilters()

    setupHidePrices()

    document.querySelector('#order-by-select').addEventListener('change', (e) => {
        q.order = e.target.value || null
        handleQuery()
    })
})
